import { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import api from '../services/api';

const clienteVacio = {
    nombre: '',
    empresa: '',
    email: '',
    telefono: '',
    contacto_emergencia_nombre: '',
    contacto_emergencia_telefono: '',
    contacto_emergencia_email: '',
    notas: ''
};

const ClientesList = () => {
    const [clientes, setClientes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [busqueda, setBusqueda] = useState('');

    // Modal
    const [showModal, setShowModal] = useState(false);
    const [clienteEditar, setClienteEditar] = useState(null);
    const [formData, setFormData] = useState(clienteVacio);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        cargarClientes();
    }, []);

    const cargarClientes = async () => {
        try {
            const response = await api.clientes.getAll();
            setClientes(response.data || []);
        } catch (err) {
            console.error('Error al cargar clientes:', err);
            toast.error('Error al cargar clientes');
        } finally {
            setLoading(false);
        }
    };

    const abrirModalNuevo = () => {
        setClienteEditar(null);
        setFormData(clienteVacio);
        setShowModal(true);
    };

    const abrirModalEditar = (cliente) => {
        setClienteEditar(cliente);
        setFormData({
            nombre: cliente.nombre || '',
            empresa: cliente.empresa || '',
            email: cliente.email || '',
            telefono: cliente.telefono || '',
            contacto_emergencia_nombre: cliente.contacto_emergencia_nombre || '',
            contacto_emergencia_telefono: cliente.contacto_emergencia_telefono || '',
            contacto_emergencia_email: cliente.contacto_emergencia_email || '',
            notas: cliente.notas || ''
        });
        setShowModal(true);
    };

    const cerrarModal = () => {
        setShowModal(false);
        setClienteEditar(null);
        setFormData(clienteVacio);
    };

    const handleChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    const handleGuardar = async () => {
        if (!formData.nombre.trim()) {
            toast.error('El nombre es obligatorio');
            return;
        }
        if (!formData.email.trim()) {
            toast.error('El email es obligatorio');
            return;
        }
        if (!formData.telefono.trim()) {
            toast.error('El teléfono es obligatorio');
            return;
        }

        setSaving(true);
        try {
            if (clienteEditar) {
                await api.clientes.update(clienteEditar.id, formData);
                toast.success('Cliente actualizado');
            } else {
                await api.clientes.create(formData);
                toast.success('Cliente creado');
            }
            cerrarModal();
            cargarClientes();
        } catch (err) {
            console.error('Error al guardar cliente:', err);
            toast.error('Error al guardar cliente');
        } finally {
            setSaving(false);
        }
    };

    const handleEliminar = async (id, nombre) => {
        toast((t) => (
            <div>
                <p>¿Eliminar cliente "{nombre}"?</p>
                <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
                    <button
                        className="btn neon small"
                        onClick={async () => {
                            toast.dismiss(t.id);
                            try {
                                await api.clientes.delete(id);
                                toast.success('Cliente eliminado');
                                cargarClientes();
                            } catch (err) {
                                toast.error('Error al eliminar');
                            }
                        }}
                    >
                        Sí, eliminar
                    </button>
                    <button
                        className="btn ghost small"
                        onClick={() => toast.dismiss(t.id)}
                    >
                        Cancelar
                    </button>
                </div>
            </div>
        ), { duration: 10000 });
    };

    // Filtrar clientes por búsqueda
    const clientesFiltrados = clientes.filter(c => {
        const termino = busqueda.toLowerCase();
        return (
            c.nombre?.toLowerCase().includes(termino) ||
            c.empresa?.toLowerCase().includes(termino) ||
            c.email?.toLowerCase().includes(termino)
        );
    });

    if (loading) {
        return <div className="loading">Cargando clientes...</div>;
    }

    return (
        <>
            <div className="card">
                <div className="card-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
                    <h2>Clientes</h2>
                    <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                        <input
                            className="input"
                            type="text"
                            placeholder="Buscar cliente..."
                            value={busqueda}
                            onChange={(e) => setBusqueda(e.target.value)}
                            style={{ width: '200px' }}
                        />
                        <button
                            className="btn neon"
                            onClick={abrirModalNuevo}
                        >
                            + Nuevo Cliente
                        </button>
                    </div>
                </div>

                <div className="card-body">
                    {clientesFiltrados.length === 0 ? (
                        <div className="empty-state">
                            <p>{busqueda ? 'No se encontraron clientes' : 'No hay clientes registrados'}</p>
                            <p style={{ color: 'var(--muted)', fontSize: '14px', marginTop: '8px' }}>
                                Los clientes te permiten autocompletar datos en las cotizaciones
                            </p>
                        </div>
                    ) : (
                        <div className="tableWrap">
                            <table className="galTable">
                                <thead>
                                    <tr>
                                        <th>Nombre</th>
                                        <th>Empresa</th>
                                        <th>Email</th>
                                        <th>Teléfono</th>
                                        <th style={{ width: '140px' }}>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {clientesFiltrados.map((cliente) => (
                                        <tr key={cliente.id}>
                                            <td>{cliente.nombre}</td>
                                            <td>{cliente.empresa || '-'}</td>
                                            <td>{cliente.email || '-'}</td>
                                            <td>{cliente.telefono || '-'}</td>
                                            <td>
                                                <div style={{ display: 'flex', gap: '8px' }}>
                                                    <button
                                                        className="btn ghost small"
                                                        onClick={() => abrirModalEditar(cliente)}
                                                    >
                                                        Editar
                                                    </button>
                                                    <button
                                                        className="btn ghost small danger"
                                                        onClick={() => handleEliminar(cliente.id, cliente.nombre)}
                                                    >
                                                        Eliminar
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>

            {/* Modal de Cliente */}
            {showModal && (
                <div className="modal-overlay" onClick={cerrarModal}>
                    <div className="modal modal-lg" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h3 className="modal-title">
                                {clienteEditar ? 'Editar Cliente' : 'Nuevo Cliente'}
                            </h3>
                            <button className="modal-close" onClick={cerrarModal}>&times;</button>
                        </div>

                        <div className="modal-body">
                            {/* Datos principales */}
                            <h4 className="modal-section-title">Datos del Cliente</h4>
                            <div className="form-grid-2">
                                <label className="field">
                                    <span className="label">Nombre *</span>
                                    <input
                                        className="input"
                                        type="text"
                                        value={formData.nombre}
                                        onChange={(e) => handleChange('nombre', e.target.value)}
                                        placeholder="Nombre del contacto"
                                    />
                                </label>

                                <label className="field">
                                    <span className="label">Empresa</span>
                                    <input
                                        className="input"
                                        type="text"
                                        value={formData.empresa}
                                        onChange={(e) => handleChange('empresa', e.target.value)}
                                        placeholder="Nombre de la empresa"
                                    />
                                </label>

                                <label className="field">
                                    <span className="label">Email *</span>
                                    <input
                                        className="input"
                                        type="email"
                                        value={formData.email}
                                        onChange={(e) => handleChange('email', e.target.value)}
                                        placeholder="correo@ejemplo.com"
                                    />
                                </label>

                                <label className="field">
                                    <span className="label">Teléfono *</span>
                                    <input
                                        className="input"
                                        type="text"
                                        value={formData.telefono}
                                        onChange={(e) => handleChange('telefono', e.target.value)}
                                        placeholder="+51 999 999 999"
                                    />
                                </label>
                            </div>

                            {/* Contacto de emergencia */}
                            <h4 className="modal-section-title" style={{ marginTop: '24px' }}>
                                Contacto de Emergencia
                                <span style={{ fontWeight: 400, fontSize: '12px', color: 'var(--muted)', marginLeft: '8px' }}>
                                    (opcional)
                                </span>
                            </h4>
                            <div className="form-grid-3">
                                <label className="field">
                                    <span className="label">Nombre</span>
                                    <input
                                        className="input"
                                        type="text"
                                        value={formData.contacto_emergencia_nombre}
                                        onChange={(e) => handleChange('contacto_emergencia_nombre', e.target.value)}
                                        placeholder="Nombre"
                                    />
                                </label>

                                <label className="field">
                                    <span className="label">Teléfono</span>
                                    <input
                                        className="input"
                                        type="text"
                                        value={formData.contacto_emergencia_telefono}
                                        onChange={(e) => handleChange('contacto_emergencia_telefono', e.target.value)}
                                        placeholder="+51 999 999 999"
                                    />
                                </label>

                                <label className="field">
                                    <span className="label">Email</span>
                                    <input
                                        className="input"
                                        type="email"
                                        value={formData.contacto_emergencia_email}
                                        onChange={(e) => handleChange('contacto_emergencia_email', e.target.value)}
                                        placeholder="correo@ejemplo.com"
                                    />
                                </label>
                            </div>

                            {/* Notas */}
                            <label className="field" style={{ marginTop: '24px' }}>
                                <span className="label">Notas</span>
                                <textarea
                                    className="input"
                                    rows={2}
                                    value={formData.notas}
                                    onChange={(e) => handleChange('notas', e.target.value)}
                                    placeholder="Notas adicionales sobre el cliente..."
                                />
                            </label>
                        </div>

                        <div className="modal-footer">
                            <button className="btn ghost" onClick={cerrarModal}>
                                Cancelar
                            </button>
                            <button className="btn neon" onClick={handleGuardar} disabled={saving}>
                                {saving ? 'Guardando...' : (clienteEditar ? 'Guardar Cambios' : 'Crear Cliente')}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ClientesList;
